// Anchor ranges to the market's latest candle, including closed-market days.
export function chartRangeStart(key, latest, offsetMinutes = 0) {
    if (key === 'All') return null;
    if (!Number.isFinite(latest)) return undefined;
    const offset = offsetMinutes * 60000;
    const date = new Date(latest + offset);
    if (key === 'YTD') return Date.UTC(date.getUTCFullYear(), 0, 1) - offset;
    if (key === '1D' || key === '5D') return latest - (key === '1D' ? 1 : 5) * 86400000;
    const months = { '1M': 1, '3M': 3, '6M': 6, '1Y': 12, '5Y': 60 }[key];
    if (!months) return undefined;
    const day = date.getUTCDate();
    date.setUTCDate(1);
    date.setUTCMonth(date.getUTCMonth() - months);
    const lastDay = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + 1, 0)).getUTCDate();
    date.setUTCDate(Math.min(day, lastDay));
    return date.getTime() - offset;
}
